import React from "react";
import { withTranslation } from "react-i18next";
import { Modal } from "reactstrap";
import { ModalBody } from "reactstrap";
import Select from "react-select";
import crossIcon from "../../../../assets/images/cross.svg";
import PatientCard from "../PatientCard";
import styles from "../TaskManagement.module.scss";
import Empty from "components/Empty";

const AssignStaffMembersModal = ({
  t,
  isModalOpen,
  closeModal,
  options,
  selectedOption,
  handleRequestStatusFilter,
  OptionsStaff,
  handleCheckboxChange,
  handleApplyCheck,
  handleCancelCheck,
  selectedStaff,
  isInsideModal,
  taskId,
}) => {
  const darkButton = "button button-round button-shadow mr-md-4 w-sm-100";
  const lightButton =
    "button button-round button-border btn-mobile-link button-dark";
  const bodyElement = (
    <>
      <h2 className={isInsideModal ? "cfs-md text-dark fw-bold" : "title"}>
        {t(
          isInsideModal
            ? "taskManagement.assginStaffMemeber"
            : "notes.selectStaffMember"
        )}
      </h2>
      <div className="margin30">
        <Select
          className="react-select-container"
          classNamePrefix="react-select"
          options={options}
          value={selectedOption}
          onChange={handleRequestStatusFilter}
        />
      </div>
      <div className={styles.assignes_staff_scroll}>
        <div>
          {OptionsStaff?.length > 0 ? (
            OptionsStaff?.map((staff) => (
              <PatientCard
                key={staff.id}
                staff={staff}
                onCheckboxChange={handleCheckboxChange}
                selectedStaff={selectedStaff}
              />
            ))
          ) : (
            <Empty Message={t("noStaffMemberFound")} />
          )}
        </div>
      </div>
      <div
        className={
          isInsideModal ? "d-flex justify-content-between pt-4" : "pt-4"
        }
      >
        <button
          className={isInsideModal ? lightButton : darkButton}
          title="save"
          onClick={(e) => {
            isInsideModal ? closeModal(e) : handleApplyCheck(e);
          }}
          disabled={isInsideModal ? false : OptionsStaff?.length === 0}
        >
          {isInsideModal ? t("notes.previousStep") : t("notes.apply")}
        </button>
        <button
          className={isInsideModal ? darkButton : lightButton}
          title="cancel"
          onClick={(e) => {
            isInsideModal ? handleApplyCheck(e) : handleCancelCheck(e);
          }}
          disabled={
            isInsideModal
              ? OptionsStaff?.length === 0 ||
                (!taskId &&
                  Object.keys(selectedStaff).filter((key) => selectedStaff[key])
                    ?.length === 0)
              : false
          }
        >
          {isInsideModal
            ? taskId
              ? t("taskManagement.update")
              : t("taskManagement.addNewTask")
            : t("notes.cancel")}
        </button>
      </div>
    </>
  );
  if (isInsideModal) {
    return bodyElement;
  }
  return (
    <Modal
      isOpen={isModalOpen}
      toggle={closeModal}
      className="modal-dialog-centered interactive-element modal-lg"
      modalClassName="custom-modal"
    >
      <span className="close-btn" onClick={closeModal}>
        <img src={crossIcon} alt="close" />
      </span>
      <ModalBody>{bodyElement}</ModalBody>
    </Modal>
  );
};
export default withTranslation()(AssignStaffMembersModal);
